import React from "react";
import { Card as AntCard } from "antd";
import { cx } from "../../utils/classNames";

export function Card({ title, subtitle, actions, className, children, ...rest }) {
  const titleNode = title ? (
    <div>
      <div className="card-title">{title}</div>
      {subtitle && <div className="card-subtitle">{subtitle}</div>}
    </div>
  ) : null;

  return (
    <AntCard className={cx("card", className)} title={titleNode} extra={actions} {...rest}>
      {children}
    </AntCard>
  );
}

export default Card;
